module.exports = __webpack_public_path__ + "quintype_logo-cdde04aab2d69deb6745.svg";